const theme = {
  colors: {
    // Jaune
    yellowPrimary: '#FFC700', // Jaune principal
    yellowBackground: 'rgba(255, 199, 0, 0.09)', // Jaune fond
    yellowBackground2: 'rgba(255, 199, 0, 0.17)', // Jaune fond 2
    yellowHoverBackground: '#f4bb00', // Hover bouton primary

    // Noir
    black: '#000000', // Noir
    blackSecondary: '#333333', // Noir secondaire

    // Blanc
    white: '#FFFFFF', // Blanc

    // Gris
    grayPrimary: '#AAAAAA', // Gris principal
    graySecondary: '#727272', // Gris secondaire
    graySecondaryBackground: 'rgba(114, 114, 114, 0.09)', // Gris secondaire fond
    darkGray: '#515050', // Gris foncé
    grayBreadcrumb: 'rgba(51, 51, 51, 0.6)', // Gris fil ariane
    grayBackground: '#F9F9F9', // Gris fond
    grayInput: '#FCFCFC', // Gris Input
    grayShadow: '#E4E3E3', // Gris ombre
    lightGray: 'rgba(235, 235, 235, 1)', // gris clair
    boxShaddowGray: 'rgba(150, 150, 150, 0.1)', // Box Shaddow
    grayPlaceholder: '#C4C4C4', // Gris placeholder

    // Bleu
    bluePrimary: '#1882FF', // Bleu texte
    blueBackground: 'rgba(24, 130, 255, 0.09)', // Bleu fond

    // Orange
    orangeText: '#F69707', // Orange texte
    orangeBackground: 'rgba(246, 151, 7, 0.09)', // Orange fond

    // Vert
    greenText: '#56D32A', // Vert texte
    greenBackground: 'rgba(86, 211, 42, 0.09)', // Vert fond

    // Rouge
    redPrimary: '#E11D48', // Rouge principal
    redText: '#F39274', // Rouge texte
    redBackground: 'rgba(243, 146, 116, 0.09)', // Rouge fond

    // Violet
    purpleText: '#2B0161', // Violet texte
    purpleBackground: 'rgba(43, 1, 97, 0.09)' // Violet fond
  },
  fonts: {
    main: 'Barlow'
  }
}

export default theme
